import React from 'react';

import { PaymentPlans } from '@pharmaplan/common';

import PaymentGateway from '../../components/PaymentGateway';
import { setDialog } from '../../reducers/dialogReducer';
import genericClasses from '../../theme/GenericClasses';
import { useAppDispatch } from '../useAppDispatch';
import strings from '../../localization';

const useUpdateCardDetails = () => {
  const dispatch = useAppDispatch();

  const updatePaymentMethod = () => {
    dispatch(
      setDialog({
        Component: (
          <PaymentGateway
            paymentPlan={PaymentPlans.basic}
            showFees={false}
            showTerms={false}
            customTitle={strings.updatePaymentDetails}
            customSubmitLabel={strings.updateNow}
            customContainer={genericClasses.removeBorder}
            isDialog
          />
        ),
        showCloseButton: false,
        heading: {
          title: '',
        },
      }),
    );
  };

  return { updatePaymentMethod };
};

export default useUpdateCardDetails;
